import { render, staticRenderFns } from "./AssignedCourse.vue?vue&type=template&id=1e22ad4e&"
import script from "./AssignedCourse.vue?vue&type=script&lang=js&"
export * from "./AssignedCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports